import { BaseCssVarValue } from '@/views/game/components/gameCardSuit/components/baseCssVarInject'
import { CopywritingBase } from '../copywriting'

export abstract class _AdvertiseImgAssembledBase extends BaseCssVarValue {
  abstract cssType: 'default' | 'small'
  /** copywrite组件的cssVar样式 */
  copywriting?: CopywritingBase;
  /** 拼接广告组件的宽度 */
  ['--advertse-img-assembled-width']?: string;
  /** 拼接广告组件的高度 */
  ['--advertse-img-assembled-height']?: string;
  /** 拼接广告组件的内边距 */
  ['--advertse-img-assembled-padding']?: string;
  /** 左边文案区域的宽高 */
  ['--introduce-left-width']?: string;
  /** 右侧广告图片的宽高(非广告图片盒子的宽高) */
  ['--advertisement-image-width']?: string
}
